// src/services/auth.service.ts
export class AuthService {
    static login(email) {
        sessionStorage.setItem('username', email);
        document.cookie = 'sessionCookie=true; path=/';
        document.cookie = `username=${encodeURIComponent(email)}; path=/`;
    }
    static logout() {
        document.cookie = 'sessionCookie=; Expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
        document.cookie = 'username=; Expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
        sessionStorage.removeItem('username');
    }
    static isAuthenticated() {
        return document.cookie.includes('sessionCookie=true') && !!this.username();
    }
    static username() {
        const m = document.cookie.match(/(?:^|; )username=([^;]+)/);
        return m ? decodeURIComponent(m[1]) : null;
    }
}
